const menuData = {

  juiceMenuItems: [
    {
      title: 'Papaya',
      // price: '$13',
      description: 'A refreshing, naturally sweet juice made from ripe papaya, blended to perfection for a smooth and tropical flavor.',
    },
    {
      title: 'Watermelon',
      // price: '$15',
      description: 'A refreshing and hydrating juice made from fresh, juicy watermelon, blended to a smooth consistency for a naturally sweet and cool drink.',
    },
    {
      title: 'Mixed Fruit',
      // price: '$17',
      description: 'A vibrant blend of fresh, seasonal fruits such as orange, pineapple, apple, and mango, juiced together for a naturally sweet and refreshing drink.',
    },
    {
      title: 'Lime',
      // price: '$14',
      description: 'A zesty and refreshing drink made from freshly squeezed limes, offering a tangy and invigorating flavor, perfect for a cooling and citrusy refreshment.',
    },
    {
      title: 'Divul (Wood Apple)',
      // price: '$19',
      description: 'A traditional Sri Lankan drink made from the pulp of the wood apple fruit, blended with water and a touch of sweetness for a unique, tangy, and refreshing flavor.',
    },
    {
      title: 'King Coconut',
      // price: '$22',
      description: 'A naturally refreshing beverage made from the sweet, nutrient-rich water of the King Coconut, offering a hydrating and tropical experience.',
    },
    {
      title: 'Avacado',
      // price: '$13',
      description: 'A creamy and smooth drink made from ripe avocado blended with milk or water, sweetened to taste, offering a rich and indulgent flavor.',
    },
    {
      title: 'Katu Anoda',
      // price: '$14',
      description: 'A refreshing drink made from the pulp of the Katu Anoda (Sour Sop) fruit, blended with water and a touch of sweetness, offering a tangy, tropical flavor with a smooth texture.',
    },
  ],

  appetizerMenuItems: [
    {
      title: 'Potato Weges',
      price: 'Rs.950',
      description: 'Crispy, golden-brown potato wedges, seasoned with a blend of herbs and spices, served hot for a deliciously crunchy and flavorful snack or side dish.',
    },
    {
      title: 'French Fries',
      price: 'Rs.950',
      description: 'Crispy, golden fries made from freshly cut potatoes, lightly seasoned and fried to perfection for a crunchy, savory treat..',
    },
  ],

  bitesMenuItems:[
    {
      title: 'Sri Lankan Omelette',
      price: 'Rs.600',
      description: 'A flavorful fusion of fresh eggs, finely chopped onions, green chilies, tomatoes, curry leaves, and a dash of local spices. Perfectly seasoned for a burst of Sri Lankan taste in every bite!',
    },
    {
      title: 'Chicken Omelette',
      price: 'Rs.750',
      description: 'A hearty blend of fresh eggs, tender chicken chunks, onions, green chilies, and aromatic spices. A satisfying dish packed with rich flavors!',
    },
    {
      title: 'Cheese Omelette',
      price: 'Rs.850',
      description: 'A creamy delight made with fresh eggs and melted cheese, complemented by a hint of seasoning for a simple yet indulgent flavor.',
    },
    {
      title: 'Garlic Omelette',
      price: 'Rs.700',
      description: 'A savory mix of fresh eggs and aromatic garlic, lightly seasoned to create a flavorful and comforting dish.',
    },
    {
      title: 'Boiled Vegetables',
      price: 'Rs.950',
      description: 'A wholesome mix of fresh, seasonal vegetables, gently boiled to retain their natural flavors and nutrients. A healthy and simple delight!',
    },
    {
      title: 'Fried Fish Koraly',
      price: 'Rs.950',
      description: 'Crispy fried Koraly fish, marinated with a blend of spices and herbs, delivering a burst of flavor in every bite. Perfectly golden and delicious!',
    },
    {
      title: 'Fried Handallo',
      price: 'Rs.1100',
      description: 'Crispy fried Handallo fish, seasoned with Sri Lankan spices for a rich, flavorful, and crunchy seafood experience.',
    },
    {
      title: 'Fried Chicken',
      price: 'Rs.1300',
      description: 'Juicy chicken pieces marinated in a blend of spices, fried to golden perfection for a crispy and flavorful delight.',
    },
    {
      title: 'Chicken Devil',
      price: 'Rs.1300',
      description: 'Spicy and tangy stir-fried chicken, tossed with onions, capsicum, and a medley of Sri Lankan spices for a fiery, flavorful treat.',
    },
    {
      title: 'Hot Butter Fish',
      price: 'Rs.1400',
      description: 'Tender fish pieces sauteed in a rich, buttery sauce with a kick of spice, garlic, and herbs, delivering a deliciously creamy and flavorful dish.',
    },
    {
      title: 'Hot Butter Chicken',
      price: 'Rs.1500',
      description: 'Succulent chicken pieces cooked in a rich, buttery sauce with a blend of aromatic spices, garlic, and chili, offering a creamy and spicy flavor in every bite.',
    },
    {
      title: 'Chicken Stew',
      price: 'Rs.1500',
      description: 'A comforting dish made with tender chicken, simmered in a rich, creamy coconut milk base with aromatic spices, vegetables, and herbs, offering a warm and flavorful experience.',
    },
    {
      title: 'Fried Fish Thyalapath',
      price: 'Rs.1600',
      description: 'Crispy fried fish, marinated in a blend of Sri Lankan spices and herbs, served with a tangy and flavorful tamarind sauce for a perfect balance of heat and sourness.',
    },
    {
      title: 'Fried Hot Butter Cuttle Fish',
      price: 'Rs.1750',
      description: 'Tender cuttlefish pieces fried to a crispy golden brown, tossed in a rich, buttery sauce with a hint of spice, garlic, and herbs for a deliciously crunchy and flavorful dish..',
    },
    {
      title: 'Seafood Devil',
      price: 'Rs.2100',
      description: 'A spicy and tangy stir-fry made with a mix of fresh seafood, including prawns, fish, and calamari, cooked with onions, capsicum, and a medley of Sri Lankan spices for a bold, flavorful dish.',
    },
    {
      title: 'Butter Fried Prawns',
      price: 'Rs.2100',
      description: 'Juicy prawns coated in a light, crispy batter and fried to golden perfection, offering a delicious crunch with every bite.',
    },
  ],

  pastaMenuItems: [
    {
      title: 'Cheese Pasta',
      price: 'Rs.1200',
      description: 'Tender pasta coated in a rich, creamy cheese sauce, seasoned with herbs and spices for a comforting and indulgent dish.',
    },
    {
      title: 'Cheese and Chicken Pasta',
      price: 'Rs.1300',
      description: 'Creamy cheese sauce envelops tender pasta and succulent chicken, seasoned with herbs and spices for a hearty, flavorful dish.',
    },
    {
      title: 'Cheese and Seafood Pasta',
      price: 'Rs.1400',
      description: 'A creamy cheese sauce paired with tender pasta and a medley of fresh seafood, including prawns, fish, and calamari, for a rich and flavorful dining experience.',
    },
  ],

  noodlesMenuItems: [
    {
      title: 'Vegetable Noodles',
      price: 'Rs.700',
      description: 'Stir-fried noodles tossed with a colorful mix of fresh vegetables, seasoned with savory sauces and spices for a light, flavorful, and satisfying dish.',
    },
    {
      title: 'Egg Noodles',
      price: 'Rs.800',
      description: 'Soft, savory noodles stir-fried with eggs and seasoned with a blend of spices and sauces, offering a simple yet flavorful dish.',
    },
    {
      title: 'Chicken Noodles',
      price: 'Rs.1000',
      description: 'Tender chicken pieces stir-fried with noodles, mixed with fresh vegetables, and seasoned with savory spices and sauces for a delicious and satisfying meal.',
    },
    {
      title: 'Mixed Noodles',
      price: 'Rs.1400',
      description: 'A flavorful blend of stir-fried noodles, chicken, vegetables, and spices, creating a deliciously satisfying dish with a perfect balance of textures and flavors.',
    },
  ],

  kottuMenuItems: [
    {
      title: 'Vegetable Kottu',
      price: 'Rs.600',
      description: 'A Sri Lankan delicacy made with finely chopped flatbread, stir-fried with a mix of fresh vegetables, spices, and herbs, offering a flavorful and hearty dish.',
    },
    {
      title: 'Egg Kottu',
      price: 'Rs.750',
      description: 'A flavorful Sri Lankan dish made with chopped flatbread, scrambled eggs, mixed vegetables, and a blend of spices, all stir-fried to perfection for a satisfying, savory meal.',
    },
    {
      title: 'Chicken Kottu',
      price: 'Rs.950',
      description: 'A popular Sri Lankan dish made with chopped flatbread, tender chicken, mixed vegetables, and a blend of aromatic spices, all stir-fried to create a hearty and flavorful meal.',
    },
    {
      title: 'Nai Miris Noodles',
      price: 'Rs.1100',
      description: 'A spicy Sri Lankan specialty made with chopped flatbread, mixed vegetables, and a fiery blend of Nai Miris (Sri Lankan chili paste), delivering a bold and flavorful kick in every bite.',
    },
    {
      title: 'Seafood Noodles',
      price: 'Rs.1200',
      description: 'A flavorful Sri Lankan dish made with chopped flatbread, mixed seafood including prawns and fish, vegetables, and a blend of aromatic spices, stir-fried to perfection for a delicious, savory experience.',
    },
    {
      title: 'Cheese Noodles',
      price: 'Rs.1450',
      description: 'A rich and creamy twist on the classic Sri Lankan Kottu, made with chopped flatbread, melted cheese, mixed vegetables, and a blend of spices, all stir-fried to create a satisfying, cheesy delight.',
    },
  ],

  riceMenuItems: [
    {
      title: 'Vegetable Fried Rice',
      price: 'Rs.600',
      description: 'Fragrant rice stir-fried with a medley of fresh vegetables, seasoned with soy sauce and aromatic spices for a light, flavorful, and satisfying dish.',
    },
    {
      title: 'Egg  Fried Rice',
      price: 'Rs.800',
      description: 'Fragrant rice stir-fried with scrambled eggs, fresh vegetables, and a blend of savory spices and soy sauce, creating a delicious and satisfying dish.',
    },
    {
      title: 'Chicken Fried Rice',
      price: 'Rs.950',
      description: 'Tender chicken pieces stir-fried with fragrant rice, mixed vegetables, and seasoned with soy sauce and spices, offering a flavorful and satisfying meal.',
    },
    {
      title: 'Set Menu',
      price: 'Rs.1000',
      description: 'A carefully curated selection of dishes, offering a balanced combination of appetizers, mains, and sides, designed to provide a complete and satisfying dining experience.',
    },
    {
      title: 'Seafood Fried Rice',
      price: 'Rs.1300',
      description: 'A flavorful stir-fry of fragrant rice, mixed with a variety of fresh seafood including prawns, fish, and calamari, seasoned with soy sauce and aromatic spices for a deliciously satisfying meal.',
    },
    {
      title: 'Biriyani Chicken',
      price: 'Rs.1400',
      description: 'Aromatic basmati rice cooked with tender chicken, infused with a blend of spices, herbs, and saffron, offering a flavorful and fragrant dish with a perfect balance of heat and richness.',
    },
    {
      title: 'Nasi Gurang',
      price: 'Rs.1500',
      description: 'A flavorful Indonesian fried rice dish made with fragrant rice, stir-fried with vegetables, eggs, and a blend of spices, often topped with crispy shallots, cucumber, and a choice of protein like chicken or prawns for a satisfying meal.',
    },
    {
      title: 'Chopsuey Rice Chicken',
      price: 'Rs.1700',
      description: 'Stir-fried rice with tender chicken pieces, mixed vegetables, and a savory blend of soy sauce and spices, offering a deliciously balanced and satisfying dish.',
    },
    {
      title: 'Mixed Seafood Chopsuey',
      price: 'Rs.1850',
      description: 'A vibrant stir-fry of prawns, fish, and calamari, cooked with a medley of fresh vegetables and seasoned with savory sauces, offering a flavorful and wholesome dish.',
    },
    {
      title: 'Mixed Rice Chopsuey',
      price: 'Rs.2100',
      description: 'Stir-fried rice with a mix of vegetables, tender chicken, and seafood, seasoned with savory sauces and spices, creating a flavorful and satisfying dish.',
    },
    {
      title: 'Green Views Specials',
      price: 'Rs.2400'
    },
  ],

};
export default menuData;